import {Button, Result, Space} from "antd";
import {isRouteErrorResponse, useNavigate, useRouteError} from "react-router-dom";
import {HomeOutlined, ReloadOutlined,} from "@ant-design/icons";

export default function ErrorPage() {
    const error = useRouteError();
    const navigate = useNavigate();

    let status = "500";
    let title = "خطای غیرمنتظره";
    let subTitle = "متأسفانه مشکلی در برنامه رخ داده است. " +
        "لطفا چند دقیقه صبر کنید و مجددا تلاش کنید." + ' ' +
        'تیم فنی در حال پیگیری و رفع این مشکل است'

    if (isRouteErrorResponse(error)) {
        status = error.status?.toString();

        if (error.status === 404) {
            title = "صفحه پیدا نشد";
            subTitle = "آدرسی که وارد کرده‌اید وجود ندارد.";
        } else if (error.status === 403) {
            title = "دسترسی غیرمجاز";
            subTitle = "شما اجازه دسترسی به این صفحه را ندارید.";
        } else {
            subTitle = error.statusText;
        }
    }

    return (
        <div
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "linear-gradient(135deg, #f0f2f5, #fafafa)",
            }}
        >
            <Result
                status={status}
                title={title}
                subTitle={subTitle}
                extra={
                    <Space>
                        <Button
                            type="primary"
                            icon={<HomeOutlined/>}
                            onClick={() => navigate("/")}
                        >
                            صفحه اصلی
                        </Button>

                        <Button
                            icon={<ReloadOutlined/>}
                            onClick={() => window.location.reload()}
                        >
                            تلاش مجدد
                        </Button>
                    </Space>
                }
            />
        </div>
    );
}
